// extracted by mini-css-extract-plugin
export default {"innerWrapper":"vx-z","tooltipWrapper":"wx-z","icon":"xx-z","tooltip":"yx-z","content":"zx-z"};